// extracted by mini-css-extract-plugin
export default {"page":"Mechatronics_page__Y2YWb"};